import CustomText from "../../common/general/CustomText/CustomText";
import { StyleSheet, Pressable, View } from "react-native";

import { HeadCircuit, ArrowsClockwise, FileText, Link, Sparkle, FolderUser } from "@phosphor-icons/react";

const getIcon = (type) => {
  switch (type) {
    case "Interactive Learning Experience":
      return Sparkle;
    case "Resource":
      return Link;
    case "Assignment":
      return FileText;
    case "Project":
      return FolderUser;
    case "Assessment":
      return HeadCircuit;
    case "Review":
      return ArrowsClockwise;
    default:
      return Sparkle;
  }
};

const CustomCourseworkMenuItem = ({ onItemPress, name, isSelected, isLast, type, isFirst }) => {
  const IconComponent = type ? getIcon(type) : null;

  return (
    <View
      style={[
        styles.item,
        {
          marginBottom: isLast ? 10 : 0,
          marginTop: isFirst ? 4 : 0,
        },
      ]}>
      <Pressable onPress={onItemPress} style={styles.pressableContainer}>
        {IconComponent && (
          <View style={styles.iconContainer}>
            <IconComponent weight="bold" size={20} color={isSelected ? "#344054" : "#98A2B3"} />
          </View>
        )}
        <View style={styles.textContainer}>
          <CustomText
            useTranslationText={false}
            text={name}
            weight={isSelected ? "ultraBold" : "400"}
            style={{ color: "#344054" }}
          />
        </View>
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  item: {
    paddingVertical: 8,
    paddingLeft: 20,
    paddingRight: 12,
    backgroundColor: "#fff",
    flexDirection: "row",
    justifyContent: "flex-start",
    borderRadius: 4,
    minHeight: 0,
  },
  pressableContainer: {
    flexDirection: "row",
    alignItems: "flex-start",
    flex: 1,
  },
  iconContainer: {
    marginRight: 8,
    marginTop: 2,
    flexShrink: 0,
  },
  textContainer: {
    flex: 1,
    justifyContent: "center",
  },
});

export default CustomCourseworkMenuItem;
